var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGear(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 13.75a3.75 3.75 0 100-7.5 3.75 3.75 0 000 7.5z",
    stroke: "#3A3544",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.352 5.086c.197.182.385.37.562.562l2.133.305c.347.604.615 1.25.797 1.922l-1.297 1.727s.023.53 0 .796l1.297 1.727a7.984 7.984 0 01-.797 1.922l-2.133.305s-.367.382-.562.562l-.305 2.133a8.062 8.062 0 01-1.922.797l-1.727-1.297a4.531 4.531 0 01-.796 0l-1.727 1.297a7.982 7.982 0 01-1.922-.797l-.305-2.133a14.33 14.33 0 01-.562-.562l-2.133-.305a8.062 8.062 0 01-.797-1.922l1.297-1.727s-.023-.53 0-.796L2.156 7.875c.18-.673.449-1.319.797-1.922l2.133-.305c.182-.192.37-.38.562-.562l.305-2.133a8.063 8.063 0 011.922-.797l1.727 1.297c.265-.023.531-.023.796 0l1.727-1.297c.673.18 1.319.449 1.922.797l.305 2.133z",
    stroke: "#3A3544",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default SvgGear;